export const MIN_ZOOM = 1;
export const MAX_ZOOM = 500;
export const TIME_AXIS_HEIGHT = 30;
export const ZOOM_FACTOR = 1.25;
export const AUTO_FOCUS_ZOOM = 60;
export const PIXEL_PER_TICK = 100;
export const MIN_SCROLLBAR_THUMB_SIZE = 24;
